import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.46967 17.4697C5.17678 17.7626 5.17678 18.2375 5.46967 18.5304C5.76256 18.8232 6.23744 18.8232 6.53033 18.5304L12 13.0607L17.4697 18.5304C17.7626 18.8233 18.2375 18.8233 18.5304 18.5304C18.8233 18.2375 18.8233 17.7626 18.5304 17.4697L13.0607 12L18.5304 6.53033C18.8233 6.23744 18.8233 5.76256 18.5304 5.46967C18.2375 5.17678 17.7626 5.17678 17.4697 5.46967L12 10.9394L6.53033 5.46969C6.23744 5.1768 5.76256 5.1768 5.46967 5.46969C5.17678 5.76259 5.17678 6.23746 5.46967 6.53035L10.9393 12L5.46967 17.4697Z"
	})
});
export default SvgClose;
